// extracted by mini-css-extract-plugin
module.exports =  {"main":"CompanyInfoForm-module_main_b91f6","title":"CompanyInfoForm-module_title_cee9d","body":"CompanyInfoForm-module_body_a53a6","row":"CompanyInfoForm-module_row_a74e4"};